<etoh-sign
  [class.ng-dirty]="showError"
  [formControl]="formControl"
  [formlyAttributes]="field"
></etoh-sign>
